import type { TopicPackageFollow } from "./display/popups/topic-package-follow/types";

export enum PopupContentType {
  AcquisitionNewsletter = "acquisition-newsletter",
  Campaign = "campaign",
  MyNewsCompletion = "my-news-completion",
  TopicPackageFollow = "topic-package-follow",
  WhyRegister = "why-register",
}

export type PopupProps<T> = T & {
  modalContainerReference?: React.RefObject<HTMLDivElement>;
  onClose: () => void;
};

export type WidgetConfig = {
  dev: WidgetConfigItems;
  production: WidgetConfigItems;
};

export type WidgetConfigItems = Record<string, unknown> & {
  my_news?: {
    completion_popup?: { isEnabled: boolean };
    landing_popup?: { isEnabled: boolean };
  };
  topic_package_follows?: TopicPackageFollow;
};
